import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { TransferStoreWorkshopDetailImportModel } from 'src/app/models/imports/transfer-store-workshop-detail-import';
import { StoreImportBalanceModel } from 'src/app/models/imports/store-balance-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { TransferStoreWorkshopDetailModel } from 'src/app/models/maintenance/transfer-store-workshop-detail.model';
import { TransferStoreWorkshopModel } from 'src/app/models/maintenance/transfer-store-workshop.model';
import { RentalStockModel } from 'src/app/models/rental/rental-stock-response.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { TransferStoreWorkshopDetailCaptureTableModel } from 'src/app/models/tables/maintenance/transfer-store-workshop-detail-capture-table.model';
import { TransferStoreWorkshopDetailTableModel } from 'src/app/models/tables/maintenance/transfer-store-workshop-detail-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TransferStoreWorkshopDetailService {

  constructor(private _httpClient: HttpClient) { }

  createAsync(transferStoreWorkshopDetailContract: TransferStoreWorkshopDetailModel): Observable<TransferStoreWorkshopDetailModel> {
    return this._httpClient.post<TransferStoreWorkshopDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshopDetail.CreateAsync}`,
      transferStoreWorkshopDetailContract);
  }

  createSomeDetails(transferStoreWorkshopDetails: TransferStoreWorkshopDetailModel[]): Observable<boolean> {
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshopDetail.CreateDetailsAsync}`, transferStoreWorkshopDetails);
  }

  deleteAsync(transferStoreWorkshopDetailId: number): Observable<TransferStoreWorkshopDetailModel> {
    return this._httpClient.delete<TransferStoreWorkshopDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshopDetail.DeleteAsync}/${transferStoreWorkshopDetailId}`);
  }

  deleteSomeDetailsAsync(transferStoreWorkshopDetailIds: Array<number>): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshopDetail.DeleteSomeDetailsAsync}`,
      transferStoreWorkshopDetailIds);
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshopDetail.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  downloadGuideImportTransferStoreWorkshop(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshopDetail.DownloadGuideImportTransferStoreWorkshop}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  exportImportErrors(alerts: PreInvoicingAlertModel[]): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshopDetail.ExportImportErrors}`, alerts,
      {
        responseType: 'blob'
      }
    );
  }

  exportDetailConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshopDetail.ExportDetailConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }


  getAllTransferStoreWorkshopDetailsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<TransferStoreWorkshopDetailTableModel>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<TransferStoreWorkshopDetailTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshopDetail.GetAllTransferStoreWorkshopDetailsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getByIdAsync(transferStoreWorkshopDetailId: number): Observable<TransferStoreWorkshopDetailModel> {
    return this._httpClient.get<TransferStoreWorkshopDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshopDetail.GetByIdAsync}/${transferStoreWorkshopDetailId}`);
  }

  getColumnsForDetailConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshopDetail.GetColumnsForDetailConsultationAsync}`);
  }

  getColumnsForCapture(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshopDetail.GetColumnsForCaptureAsync}`);
  }

  getColumnsForShopStock(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshopDetail.GetColumnsForShopStockAsync}`);
  }

  getDetailsByTransferStoreWorkshopIdAsync(transferStoreWorkshopId: number): Observable<Array<TransferStoreWorkshopDetailModel>> {
    return this._httpClient.get<Array<TransferStoreWorkshopDetailModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshopDetail.GetDetailsByTransferStoreWorkshopIdAsync}/${transferStoreWorkshopId}`);
  }

  getListStocksInCostCenter(transferStoreWorkshop: TransferStoreWorkshopModel): Observable<Array<RentalStockModel>> {
    return this._httpClient.post<Array<RentalStockModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshopDetail.GetListStocksInCostCenter}`,
      transferStoreWorkshop);
  }

  getStocksInCostCenterWithPagination(transferStoreWorkshopId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<RentalStockModel>> {
    const params = new HttpParams().set('transferStoreWorkshopId', transferStoreWorkshopId).set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<RentalStockModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshopDetail.GetStocksInCostCenterWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getDetailsForCapture(page: number, limit: number, columnSort: string | null, ascendant: boolean, transferStoreWorkshopId: number): Observable<PagedResponseModel<TransferStoreWorkshopDetailCaptureTableModel>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('transferStoreWorkshopId', transferStoreWorkshopId);
    return this._httpClient.get<PagedResponseModel<TransferStoreWorkshopDetailCaptureTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshopDetail.GetDetailsForCaptureAsync}`,
      { params: params }
    );
  }

  getStocksByArticleIdStoreId(rentalStockModel: RentalStockModel): Observable<number> {
    return this._httpClient.post<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshopDetail.GetStocksByArticleIdStoreId}`,
      rentalStockModel);
  }

  getTransferStoreWorkshopDetailByKeys(transferStoreWorkshopId: number, storeId: number, articleId: number): Observable<TransferStoreWorkshopDetailModel> {
    const params = new HttpParams().set('transferStoreWorkshopId', transferStoreWorkshopId).set('articleId', articleId).set('storeId', storeId);
    return this._httpClient.get<TransferStoreWorkshopDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshopDetail.GetTransferStoreWorkshopDetailByKeysAsync}`,
      { params: params });
  }

  importTransferDetails(transferDetailImports: Array<TransferStoreWorkshopDetailImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshopDetail.ImportTransferDetailsAsync}`,
      transferDetailImports);
  }

  importStoreBalance(storeBalances: Array<StoreImportBalanceModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshopDetail.ImportStoreBalancesAsync}`,
      storeBalances);
  }

  updateAsync(transferStoreWorkshopDetailContract: TransferStoreWorkshopDetailModel): Observable<TransferStoreWorkshopDetailModel> {
    return this._httpClient.put<TransferStoreWorkshopDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferStoreWorkshopDetail.UpdateAsync}`,
      transferStoreWorkshopDetailContract);
  }
}
